let PackagesItem = [
    {
        id: 1,
        trackTitle: "Pro Track",
        trackSubtitle: "Gives access to both Junior and Pro tracks, recordings are included. Focuses on deep tech content around Angular.",
        trackPrice: "$149",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1631270995428x786123834584203300',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "Gives access to Junior track only with no recordings. Focuses on entry-level content around Angular.",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1631271857831x273898028285558800',
    },
  ];
  
  export default PackagesItem;
  